/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as LabelDefs from '../../../com/atproto/label/defs.defs'

const $nsid = 'app.bsky.actor.link'

type $nsid = typeof $nsid

export { $nsid }

/** A link shown on the account's profile. The profile record's links field sets which links are shown, and in what order. */
type Main = {
  $type: 'app.bsky.actor.link'

  /**
   * The link destination, an https URL.
   */
  url: l.UriString

  /**
   * The destination site's icon, uploaded when the link is saved.
   */
  icon?: l.BlobRef

  /**
   * Optional label for the link. Clients can fall back to the destination's domain.
   */
  title?: string

  /**
   * Self-label values for this link.
   */
  labels?: l.$Typed<LabelDefs.SelfLabels> | l.Unknown$TypedObject
  createdAt: l.DatetimeString
}

export type { Main }

/** A link shown on the account's profile. The profile record's links field sets which links are shown, and in what order. */
const main = /*#__PURE__*/ l.record<'tid', Main>(
  'tid',
  $nsid,
  /*#__PURE__*/ l.object({
    url: /*#__PURE__*/ l.string({ format: 'uri' }),
    icon: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.blob({
        accept: ['image/png', 'image/jpeg', 'image/webp'],
        maxSize: 100000,
      }),
    ),
    title: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxLength: 320, maxGraphemes: 40 }),
    ),
    labels: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.typedUnion(
        [
          /*#__PURE__*/ l.typedRef<LabelDefs.SelfLabels>(
            (() => LabelDefs.selfLabels) as any,
          ),
        ],
        false,
      ),
    ),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { main }

const $type = $nsid

type $type = typeof $type

export { $type }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main)
export const $build = /*#__PURE__*/ main.build.bind(main)
export const $assert = /*#__PURE__*/ main.assert.bind(main)
export const $check = /*#__PURE__*/ main.check.bind(main)
export const $cast = /*#__PURE__*/ main.cast.bind(main)
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main)
export const $matches = /*#__PURE__*/ main.matches.bind(main)
export const $parse = /*#__PURE__*/ main.parse.bind(main)
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main)
export const $validate = /*#__PURE__*/ main.validate.bind(main)
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)
